<template>
  <v-col cols="12" class="fill-height">
    <v-card width="100%" height="100%">
      <v-row no-gutters class="pa-2" align="center">
        <v-btn icon small @click="$router.push(`/Hierarchy`)">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
        <v-divider vertical class="mx-1"></v-divider>
        <span class="title">Hierarchy Maintenance - {{ item.name }}</span>
        <v-spacer></v-spacer>
        <span v-if="isDragging">dragging</span>
      </v-row>

      <v-divider></v-divider>

      <v-col cols="12" class="ma-0 pa-0" style="height: calc(100vh - 121px)">
        <v-row no-gutters class="fill-height">
          <v-col
            cols="3"
            class="fill-height"
            style="border-right: 1px solid lightgrey"
          >
            <v-subheader>Filter Values</v-subheader>
            <v-row
              no-gutters
              @drop="dragFinish($event)"
              @dragover.prevent
              justify="center"
              class="pa-5"
              style="border: 1px dotted lightgrey; background: lightgrey"
            >
              <div class="custom-text">Drop item here to create a root</div>
            </v-row>
            <v-list dense class="ma-0 pa-0">
              <v-list-item
                v-for="(item, idx) in availableFilterValues"
                :key="idx"
                class="elevation-1"
                draggable="true"
                @dragstart="dragStart(item, $event)"
                @dragover.prevent
              >
                {{ item.value }}
              </v-list-item>
            </v-list>
          </v-col>
          <v-col cols="9" class="fill-height">
            <v-row no-gutters class="pa-2 fill-height">
              <organogram ref="organogram" :structure="structure" mode="edit" />
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-card>
  </v-col>
</template>

<script>
import organogram from "@/components/Organogram/organogram";

export default {
  components: {
    organogram,
  },
  data() {
    return {
      draggingItem: null,
      item: {
        name: null,
        groups: [],
      },
      filterValues: [],
      structure: [],
    };
  },
  mounted() {
    let self = this;

    self.fetchData();
  },
  computed: {
    isDragging() {
      return this.draggingItem != null;
    },
    valuesInUse() {
      let self = this;

      let retVal = [];

      self.structure.forEach((element) => {
        self.findValuesRecursive(retVal, element);
      });

      return retVal;
    },
    availableFilterValues() {
      let self = this;

      return self.filterValues.filter((value) => {
        var foundInUse = self.valuesInUse.find((el) => {
          return el.id == value.id;
        });

        if (foundInUse == null) {
          return value;
        }
      });
    },
  },
  methods: {
    fetchData() {
      let self = this;

      self.get(`Hierarchy?id=${self.$route.params.id}`).then((r) => {
        if (r.data.success) {
          self.item = r.data.data;

          self.fetchFilter();
          self.fetchHierarchyStructure();
        }
      });
    },
    fetchFilter() {
      let self = this;

      self
        .get(
          `DataProvider/GetFilterWithValues?id=${self.item.providerFilterId}`
        )
        .then((r) => {
          if (r.data.success) {
            self.filterValues = r.data.data.values;
          }
        });
    },
    fetchHierarchyStructure() {
      let self = this;

      self
        .get(`Hierarchy/GetStructure?id=${self.$route.params.id}`)
        .then((r) => {
          if (r.data.success) {
            self.$store.commit("setOrganogram", r.data.data);
            self.structure = r.data.data;
          }
        });
    },
    findValuesRecursive(retVal, group) {
      let self = this;

      retVal.push(group.providerFilterValue);

      if (group.children.length > 0) {
        group.children.forEach((element) => {
          self.findValuesRecursive(retVal, element);
        });
      }
    },
    dragStart(item, ev) {
      ev.dataTransfer.setData("filterId", item.id);
      ev.dataTransfer.setData("methodType", "create");
      ev.dataTransfer.dropEffect = "move";

      this.draggingItem = item;
    },
    dragEnd() {
      this.draggingItem = null;
    },
    dragFinish() {
      let self = this;

      self.addToGroup();
    },
    addToGroup() {
      let self = this;

      self
        .post(`Hierarchy/CreateFilter`, {
          hierarchyId: self.$route.params.id,
          providerFilterValueId: self.draggingItem.id,
          parentId: null,
        })
        .then((r) => {
          if (r.data.success) {
            self.structure.push(r.data.data);
          }
        });
    },
    saveItem() {
      let self = this;

      self.put(`Hierarchy?id=${self.item.id}`, self.item).then(() => {});
    },
  },
};
</script>

<style>
</style>